import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { DownloadOutlined, TableOutlined } from '@ant-design/icons';
import { Button, Col, Progress, Row, Spin, Upload } from 'antd';
import { axiosErrorHandler, downloadAsFile, showErrorNotification } from "../../../../../swzutils";
import axios from "axios";
import ErrorList from "../../../components/ErrorList";
import { ImportFormatEnum } from "../../../api/Representation";
const UploadFileStep = ({ active, uploadUri, importFormat, onComplete, onBack }) => {
    const [uploadProgress, setUploadProgress] = useState(0);
    const [showSpinner, setShowSpinner] = useState(false);
    const [errors, setErrors] = useState(null);
    const displayUploadErrorMessage = (file) => {
        if (file.response?.messages) {
            setErrors(file.response.messages);
        }
        else if (file.error && file.error.status === 413) { // Status 413 - Request Entity Too Large
            showErrorNotification("File is too large to upload");
        }
        else {
            showErrorNotification("Unknown error uploading file");
        }
    };
    const downloadSample = () => {
        setShowSpinner(true);
        axios.get(`/admin/v1/consignments/imports/sample-csv?format=${importFormat}`)
            .then(response => {
            if (response.data) {
                downloadAsFile(response.data, `subtrux-import-${importFormat}.csv`);
            }
            else {
                showErrorNotification("Unknown error downloading sample file");
            }
        })
            .catch(axiosErrorHandler)
            .finally(() => setShowSpinner(false));
    };
    const clearErrorsAndRetry = () => {
        setUploadProgress(0);
        setErrors(null);
    };
    if (!active) {
        return null;
    }
    return (_jsx(Spin, { spinning: showSpinner, children: errors ?
            _jsx(Row, { children: _jsxs(Col, { xs: { span: 24, offset: 0 }, md: { span: 12, offset: 6 }, children: [_jsx(ErrorList, { title: "Import Failed", subTitle: "The import file contains the following errors:", errors: errors }), _jsx(Button, { type: "default", htmlType: "button", size: "large", onClick: clearErrorsAndRetry, children: "Clear errors and retry" })] }) })
            :
                _jsxs("div", { children: [_jsxs("div", { className: "table-operations clearfix", children: [_jsx(Button, { type: "default", htmlType: "button", onClick: onBack, children: "\u00AB Back" }), _jsxs(Button, { type: "default", className: "pull-right", htmlType: "button", onClick: downloadSample, children: [_jsx(DownloadOutlined, {}), "\u00A0Download Sample CSV"] })] }), _jsx(Upload.Dragger, { name: "uploadFile", accept: ".csv", withCredentials: true, showUploadList: false, action: uploadUri, onChange: (info) => {
                                const status = info.file.status;
                                //console.log("status:" + status + ".  info", info);
                                if (status === 'uploading' && info.file.percent) {
                                    setUploadProgress(info.file.percent);
                                }
                                if (status === 'done') {
                                    setUploadProgress(0);
                                    onComplete(info.file.response);
                                }
                                if (status === 'error') {
                                    setUploadProgress(0);
                                    displayUploadErrorMessage(info.file);
                                }
                            }, children: uploadProgress ?
                                _jsx(Progress, { percent: uploadProgress, status: "active" })
                                :
                                    _jsxs("div", { children: [_jsx("p", { className: "ant-upload-drag-icon", children: _jsx(TableOutlined, {}) }), _jsxs("div", { className: "upload-instructions", children: [_jsx("p", { className: "ant-upload-text", children: "Click to select or drag a file in to this area to commence the import" }), _jsx("p", { className: "ant-upload-hint", children: "Only csv files are supported" })] })] }) })] }) }));
};
export default UploadFileStep;
